import { useEffect, useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import { SelectObject } from '@components/SelectObject'
import type { FilterOption } from '@models/Filter'
import type { GebiedLabel } from '@models/GebiedLabel'

import { PropertyRow } from '../../../theme/components/PropertyRow'
import { StyledError } from '../../../theme/components/StyledError'
import { useCreateLabel } from '../../hooks/useCreateLabel'

export { CreateGebiedLabel }

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  projectType: GebiedLabel['projectType']
  verantwoordelijke: string
  gebieden: FilterOption[]
}

const CreateGebiedLabel = ({
  open,
  setOpen,
  projectType,
  verantwoordelijke,
  gebieden,
}: Props) => {
  const { mutate: createLabel, error } = useCreateLabel()

  const [gebied, setGebied] = useState<FilterOption | null>(null)
  const [label, setLabel] = useState('')
  const [errors, setErrors] = useState<{ gebied?: string; label?: string }>({})

  const handleSubmit = () => {
    setErrors({
      gebied: gebied ? undefined : 'Gebied is verplicht',
      label: label ? undefined : 'Label is verplicht',
    })

    if (!gebied || !label) {
      return
    }

    createLabel(
      {
        label: {
          projectType,
          verantwoordelijke,
          gebiedscode: gebied.code,
          label,
        },
      },
      { onSuccess: () => setOpen(false) },
    )
  }

  useEffect(() => {
    if (open) {
      setErrors({})
    } else {
      setGebied(null)
      setLabel('')
    }
  }, [open])

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>Label in nieuw gebied toevoegen</DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <PropertyRow label="Verantwoordelijke" value={verantwoordelijke} />

        <SelectObject
          label="Gebied"
          options={gebieden}
          value={gebied}
          onChange={(value) => setGebied(value)}
          error={!!errors.gebied}
          helperText={errors.gebied}
        />

        <TextField
          label="Label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          variant="standard"
          error={!!errors.label}
          helperText={errors.label}
        />

        <StyledError error={error} />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpen(false)} autoFocus>
          Sluiten
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          endIcon={<AddIcon />}
        >
          Toevoegen
        </Button>
      </DialogActions>
    </Dialog>
  )
}
